module.exports = __webpack_public_path__ + "img/touchngo.e7cb9f0.png";